<template>
  <div class="preloader flex-column justify-content-center align-items-center">
    <img
      class=""
      src="@/assets/img/salvationLogo.png"
      alt="AdminLTELogo"
      height="80"
      width="80"
    />
  </div>
</template>

<script>
export default {
  created() {

    
  },
};
</script>

<style>
</style>